import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";

import { FC } from "react";


export interface SectionHero4Props {
  className?: string;
}

const SectionHero4: FC<SectionHero4Props> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero relative ${className} `}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="hidden flex-shrink-0 lg:flex flex-col items-start pb-4 lg:pb-48 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-bold text-6xl text-white mb-16 md:mb-4">
            Affordable Car Rentals<br /> for Every Journey
          </h2>
        </div>
      </div>
      <div className="hidden lg:block z-10 mb-12  w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};


export default SectionHero4;
